<div class="tab-notes-container">
  <div class="header">
    <h1>Tab Notes Management</h1>
    <p class="subtitle">Manage notes for each tab that will be displayed to users</p>
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading tab notes...</p>
    </div>
  }

  <!-- Tab Notes List -->
  @if (!loading) {
    <div class="accordion-container">
      <mat-accordion class="tab-notes-accordion">
        @for (tab of tabs; track tab.id) {
          <mat-expansion-panel class="tab-note-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panel-header-content">
                  <div class="panel-header-main">
                    <mat-icon>note</mat-icon>
                    <span class="tab-name">{{ tab.name }}</span>
                    @if (hasNote(tab.id)) {
                      <span class="badge has-note">Has Note</span>
                    } @else {
                      <span class="badge no-note">No Note</span>
                    }
                  </div>
                  @if (hasNote(tab.id)) {
                    <div class="panel-header-meta">
                      <span class="date-badge">Updated: {{ formatDate(getTabNote(tab.id)!.updated_at) }}</span>
                    </div>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Panel Content -->
            <div class="panel-content">
              <div class="editor-section">
                <div class="editor-header">
                  <h3 class="section-title">Note Content</h3>
                  <div class="editor-actions">
                    <button 
                      mat-raised-button 
                      color="primary"
                      [disabled]="isSaving(tab.id)"
                      (click)="saveTabNote(tab.id)">
                      @if (isSaving(tab.id)) {
                        <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
                      } @else {
                        <mat-icon>save</mat-icon>
                      }
                      {{ hasNote(tab.id) ? 'Update' : 'Save' }} Note
                    </button>
                    @if (hasNote(tab.id)) {
                      <button 
                        mat-raised-button 
                        color="warn"
                        (click)="deleteTabNote(tab.id)">
                        <mat-icon>delete</mat-icon>
                        Delete Note
                      </button>
                    }
                  </div>
                </div>

                <div class="quill-editor-container">
                  <quill-editor
                    [modules]="quillModules"
                    [ngModel]="getEditingContent(tab.id)"
                    (ngModelChange)="onContentChange(tab.id, $event)"
                    placeholder="Enter note content here. You can use text formatting and insert images (base64 encoded).">
                  </quill-editor>
                </div>

                @if (hasNote(tab.id)) {
                  <div class="note-info">
                    <div class="info-item">
                      <span class="info-label">Created:</span>
                      <span class="info-value">{{ formatDate(getTabNote(tab.id)!.created_at) }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Last Updated:</span>
                      <span class="info-value">{{ formatDate(getTabNote(tab.id)!.updated_at) }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</div>
